import type { AccountForChildEligibilityDetails } from '@generated-types';
import { createContext, useContext } from 'react';

export interface ChildCardContextType {
    childEligibility: AccountForChildEligibilityDetails;
}

export const ChildCardContext = createContext<ChildCardContextType | undefined>(undefined);

export const useChildCardContext = () => {
    const context = useContext(ChildCardContext);
    if (!context) {
        throw new Error('ChildCard compound components must be used within ChildCard');
    }
    return context;
};
